import React, { useRef, useEffect } from 'react'
import './Img.css'

interface VideoWebFrameProps {
  src: string
  index: number
  isHovered: boolean
  isLoading: boolean
  onLoadStart: () => void
  onLoadEnd: () => void
}

const VideoWebFrame: React.FC<VideoWebFrameProps> = ({
  src,
  index,
  isHovered,
  isLoading,
  onLoadStart,
  onLoadEnd
}) => {
  const videoRef = useRef<HTMLVideoElement>(null)

  useEffect(() => {
    const video = videoRef.current
    if (video == null) return

    if (isHovered) {
      video.currentTime = 0
      void video.play()
    } else {
      void video.pause()
      video.currentTime = 0
    }
  }, [isHovered])

  const handleDoubleClick = (): void => {
    const video = videoRef.current
    if (video == null) return

    if (video.requestFullscreen != null) {
      void video.requestFullscreen()
    } else if ((video as any).webkitRequestFullscreen != null) {
      void (video as any).webkitRequestFullscreen()
    } else if ((video as any).msRequestFullscreen != null) {
      void (video as any).msRequestFullscreen()
    }
  }

  return (
    <video
      ref={videoRef}
      className='video-element'
      src={src}
      muted
      playsInline
      loop
      controls={isHovered}
      onDoubleClick={handleDoubleClick}
      onLoadStart={onLoadStart}
      onLoadedData={onLoadEnd}
      onError={onLoadEnd}
    />
  )
}

export default VideoWebFrame
